module.exports = __webpack_public_path__ + "img/56.e8a71f06.jpg";